import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from '../Haldi/HaldiHead';
import HaldiImage from '../Haldi/HaldiImage';
import HaldiBook from '../Haldi/HaldiBook';
import HaldiGallery from '../Haldi/HaldiGallery';
import HaldiCraft from '../Haldi/HaldiCraft';
import HaldiInstagram from '../Haldi/HaldiInstagram';
import HaldiLogoslider from '../Haldi/HaldiLogoslider';
import HaldiService from '../Haldi/HaldiService';

export default function Mehandi() {
    const subheadData = {
      image: '../image/mehandi-banner.webp',
      heading: 'Vibrant Mehandi Looks for Joyful Celebrations',
      pagename: 'Mehandi',
    }


    const headdata = {
        title: "Celebrate the Artistry of Mehandi Style",
        heading: "Radiant Bridalwear, Curated with Heart",
        description:"At Sonam Label, Mehandi elegance is reimagined through handcrafted ensembles that marry timeless artistry with modern charm. Each outfit features intricate embroidery, lively colour palettes, fluid drapes, and signature artisanal detailing, designed to capture the joy and movement of your celebration. Crafted for comfort, confidence, and a natural bridal glow, our Mehandi collection ensures every bride feels effortlessly graceful, radiant, and fully celebrated on her special day.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldiimage = [
        { src: "../image/mehandi-img-1.webp", alt: "mehandi" },
        { src: "../image/mehandi-img-2.webp", alt: "mehandi" },
        { src: "../image/mehandi-img-3.webp", alt: "mehandi" },
    ];


    const haldiService = {
      tagline: "Mehandi Essentials",
      heading: "Embrace Tradition with Bold, Timeless Style",
      image: "/image/mehandi-service.webp",
      accordions: [
        {
          title: "Curated Mehandi Looks",
          description:"Receive personalised guidance on selecting accessories that harmonise with your outfit. From floral jewellery to statement pieces, our stylists help you choose colours, textures, and finishes that highlight your radiance."
        },
        {
          title: "Floral & Jewellery Styling",
          description:"Enhance your look with handpicked floral accessories and jewellery designed to complement your outfit and elevate your Mehandi style."
        },
        {
          title: "Bride-Focused Silhouettes",
          description:"Every silhouette is tailored with the bride in mind, balancing comfort and elegance while allowing you to move freely and celebrate with ease."
        },
        {
          title: "Trousseau Mini-Curation",
          description:"Build a cohesive Mehandi wardrobe with select pieces that transition effortlessly from ceremony rituals to post-event celebrations."
        },
        {
          title: "Hand-Crafted Ritual Gifts",
          description:"Add thoughtful touches with carefully curated ritual gifts, hand-packed to reflect tradition, celebration, and heartfelt charm."
        },
      ]
    };


    const haldigallery = [
        { src: "../image/mehandigallery-1.webp"},
        { src: "../image/mehandigallery-2.webp"},
        { src: "../image/mehandigallery-3.webp"},
        { src: "../image/mehandigallery-4.webp"},
        { src: "../image/mehandigallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Elevating Every Mehandi Moment",
      description:"Your Mehandi ensemble should embody joy, tradition, and comfort. At Sonam Label, we craft bespoke pieces that celebrate cultural artistry with contemporary ease featuring hand embellished fabrics, graceful drapes, and exquisite detailing. Designed for movement, celebration, and memorable moments, each outfit is created to make you feel radiant, confident, and beautifully yourself, reflecting both elegance and meaningful cultural expression."
    };


    const haldiInsta = [
      {image: "/image/mehandiinsta-1.webp"},
      {image: "/image/mehandiinsta-2.webp"},
      {image: "/image/mehandiinsta-3.webp"},
      {image: "/image/mehandiinsta-4.webp"},
      {image: "/image/mehandiinsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <HaldiImage haldiimage={haldiimage}/>
    <HaldiLogoslider/>
    <HaldiService haldiService={haldiService}/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}
